import React, { useState } from "react";
import "./form.scss";
import StepsWizard from "components/StepsWizard";
import { useTranslation } from "react-i18next";
import { useGetReportInformationFirstStepQuery } from "features/api/reports/reportsSlice";
import { LocalStorageKey, useGetUserData } from "common/helpers/userData";
import { useReports } from "hooks/useReports";
import { ReportInformationFirstStep } from "models/ReportInformationFirstStep";
import { useLocationForReportType } from "hooks/useLocationForReportType";
import AccompanyingInformations from "./components/AccompanyingInformations";
import ReportDetailsForm from "./components/ReportDetailsForm";

// this component render when we click on report from screen "inProgress" or "inFollowup" and we navigate to new route
const ReportDetails = () => {
  const { t } = useTranslation();
  const [currStep, setCurrStep] = useState(1);
  const { getReportId } = useReports();
  const reportId = getReportId();
  const selectedRole = useGetUserData(LocalStorageKey.SelectedRole)?.value;

  const { data: reportDetails }: { data: ReportInformationFirstStep } =
    useGetReportInformationFirstStepQuery<ReportInformationFirstStep>({
      reportID: reportId,
      role: selectedRole,
      isInProgress: useLocationForReportType() === "inprogressInsideReport",
    });

  if (reportDetails) {
    return (
      <div className="reportsContainer">
        <div className="stepsWizardContainer spaceTop">
          <h2 className="title borderBottom">{t("titleReportStages")}</h2>
          <StepsWizard
            currStep={currStep}
            steps={[
              { number: 1, text: t("wizardStep1Title") },
              { number: 2, text: t("wizardStep2Title") },
              { number: 3, text: t("wizardStep3Title") },
            ]}
          />
        </div>

        <ReportDetailsForm
          currStep={currStep}
          setCurrStep={setCurrStep}
          reportDetails={reportDetails}
        />
        <AccompanyingInformations
          licenseNumber={reportDetails?.vehicleDetails?.licenseNumber}
          reportId={reportDetails?.reportId}
        />
      </div>
    );
  }
  return <div>LOADNIG...</div>;
};

export default ReportDetails;
